import axios from './axios'

export const fetch_seeker = async (seekerId) => {
  try{
    var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/seekers/${seekerId}`
  
    var config = {
      method: 'get',
      url: url,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const update_seeker_rating = async (seekerId, rating) => {
  try{
    var data = JSON.stringify({
      "rating": rating
    });

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/seekers/${seekerId}/rating`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_comments = async (seekerId, limit, skip) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/seekers/${seekerId}/comments?`

  if(skip)
    url += `&skip=${skip}`
  if(limit)
    url += `&limit=${limit}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_comment = async (seekerId, object) => {
  try{
    var data = JSON.stringify(object);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/seekers/${seekerId}/comments`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}